var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import TotalRate from '../rates/TotalRate';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.render = function () {
        var _a = this.props, outcome = _a.outcome, gridLocalization = _a.gridLocalization, section = _a.section;
        if (outcome === undefined) {
            return false;
        }
        var rateIds = outcome.get('rates');
        var renderRates = [];
        var props = {
            section: section,
            gridLocalization: gridLocalization
        };
        rateIds.map(function (rateId) {
            renderRates.push(_jsx("div", __assign({ className: 'cols' }, { children: _jsx(TotalRate, __assign({ id: rateId }, props)) }), rateId));
        });
        return (_jsx("div", __assign({ className: 'item total' }, { children: _jsxs("div", __assign({ className: 'rows' }, { children: [_jsx("div", __assign({ className: 'cols' }, { children: _jsx("span", __assign({ className: 'label text-center' }, { children: outcome.get('teamOne') })) })), renderRates] })) })));
    };
    default_1.propTypes = {
        gridLocalization: PropTypes.object.isRequired,
        outcome: PropTypes.object.isRequired,
        section: PropTypes.string.isRequired
    };
    return default_1;
}(React.Component));
export default default_1;



// WEBPACK FOOTER //
// ./src/components/grid/event/outcomes/WhoHigherOutcome.jsx